import { render } from "./EditorAddendum.vue?vue&type=template&id=6dcc964e&scoped=true"
import script from "./EditorAddendum.vue?vue&type=script&lang=js"
export * from "./EditorAddendum.vue?vue&type=script&lang=js"

import "./EditorAddendum.vue?vue&type=style&index=0&id=6dcc964e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcc964e"]])

export default __exports__